
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { GetStaticPaths, GetStaticProps } from 'next';
import { isMediaTemplateFreeToTry } from '@/lib/mediaTemplateFreePlan';
import MediaTemplateLandingPage from '@/components/templates/MediaTemplateLandingPage';
import { getMediaTemplatesByKind, ImageTool, MEDIA_TEMPLATE_LANDING_LOCALES, } from '@/constants/mediaTemplates';
interface ImageTemplatePageProps {
    template: ImageTool;
    freeToTry: boolean;
}
const ImageTemplatePage = ({ template, freeToTry }: ImageTemplatePageProps) => (<MediaTemplateLandingPage template={template} kind='image' parentPath='/ai-image-generator' parentLabel='AI Image Generator' freeToTry={freeToTry}/>);
export const getStaticPaths: GetStaticPaths = async () => {
    const templates = getMediaTemplatesByKind('image').filter((template): template is ImageTool & {
        slug: string;
    } => Boolean(template.slug));
    const paths = templates.flatMap((template) => MEDIA_TEMPLATE_LANDING_LOCALES.map((locale) => ({
        params: { slug: template.slug },
        locale,
    })));
    return {
        paths,
        fallback: false,
    };
};
const getStaticProps: GetStaticProps<ImageTemplatePageProps> = async ({ params, }) => {
    const template = getMediaTemplatesByKind('image').find((item) => item.slug === params?.slug);
    if (!template) {
        return { notFound: true };
    }
    return {
        props: {
            template,
            // Worked out here so the model catalogs stay out of the page bundle.
            freeToTry: isMediaTemplateFreeToTry(template),
        },
    };
};
export default ImageTemplatePage;

    async function __Next_Translate__getStaticProps__1a12955d327__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/ai-image-generator/templates/[slug]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a12955d327__ as getStaticProps }
  